export type MaterialBasketItemEditingDetails = {
  itemId: string;
  itemName: string;
  itemNumber: string;
  warehouseId?: string;
  manufacturerId?: string;
  /**
   * @about warehouse only, used for moving item to other order job directly
   */
  serviceCaseId?: string;
  /**
   * @about warehouse only, used for moving item to other order job directly
   */
  serviceOrderId?: string;
  /**
   * @about warehouse only, used for moving item to other order job directly
   */
  serviceJobId?: string;
};
